<app-modal>
  <app-loading *ngIf="isLoading"></app-loading>
  <ng-container *ngIf="!isLoading">
    <app-modal-header
      [title]="T.common.add_item | translate: { item: selectedRiskTypeTitle }"
      [showDelete]="false"
      (closed)="closeModal()">
    </app-modal-header>

    <app-modal-body>
      <section class="toggle-btn" [class.mb-3]="this.selectedRiskType === riskTypes.Risk && useRiskSearch">
        <app-toggle-button
          [objects]="listToggleOptions"
          [currentlySelectedObject]="selectedListOption"
          [bindProperty]="'displayText'"
          (clicked)="toggleListChange($event)"
        ></app-toggle-button>
      </section>

      <app-suggested-risks-list
        *ngIf="this.selectedRiskType === riskTypes.Risk && useRiskSearch"
        [isWithinAddRiskModal]="true"
        (prefillFormEvent)="handlePrefillForm($event)">
      </app-suggested-risks-list>

      <section class="row col-row-space custom-gutters section-padding" [formGroup]="form">
        <div class="selection col-12 mb-2">
          <app-text-field
            [ngClass]="{'not-editable-title': usedPreDefinedRisk}"
            [showOutlined]="true"
            [removeBorders]="true"
            [displayError]="triggerErrors"
            [formGroup]="form"
            formControlName="riskTitle"
            [useReactiveMessages]="true"
            [maxLength]="250"
            [disableMargin]="true"
            [required]="true"
            [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'">
          </app-text-field>
        </div>

        <div class="col-12 col-lg-6 d-flex mb-2" *ngIf="!dateReseter">
          <app-datepicker
            [date]="getDueDate"
            [minDate]="today"
            (dateChanged)="setDueDate($event)"
            [placeholder]="T.defaultLocalizations.due_date.one | translate"
            [showPlaceholderFirst]="true"
            [disableMargin]="true"
            [showOutlined]="true">
          </app-datepicker>
        </div>
        <div class="col-12 col-lg-6 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [filterByModuleObjectType]="false"
            [displayError]="triggerErrors"
            [required]="true"
            contentEditable="false"
            [filterType]="filterTypes.Risk_Status"
            [excludeFilterValues]="exludeRiskStatuses"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="(T.common.status.one | translate) + '*'"
            [disableMargin]="true"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>

        <div class="col-12 col-lg-6 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [label]="localisedLikelihood + '*'"
              [disabled]="selectedRiskType === riskTypes.Issue"
              [displayError]="triggerErrors"
              [disableRequiredText]="true"
              [excludeFilterValues]="excludeDropdownValuesArr"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Risk_Likelihood"
              [currentlySelectedSettingValue]="likelihoodValue?.toString()"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [disableMargin]="true"
              [required]="true"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [label]="(T.common.impact.one | translate) + '*'"
              [displayError]="triggerErrors"
              [disableRequiredText]="true"
              [required]="true"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Risk_Impact"
              [currentlySelectedSettingValue]="impactValue?.toString()"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [disableMargin]="true"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div [ngTemplateOutlet]="riskRAGTemplate"></div>
        </div>
        <div class="container-with-bottom-element d-flex flex-column col-12 mb-2">
          <div class="selection">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [displayError]="triggerErrors"
              [filterType]="filterTypes.Owner"
              [required]="true"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [disableMargin]="false"
              [typeahead]="true"
              [removeIcon]="true"
              [removeBorders]="true"
              [showOutlined]="true"
              [useSearch]="false"
              [label]="(T.defaultLocalizations.owner.one | translate) + '*'"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
          </div>
          <div class="d-flex">
            <app-button-transparent
              size="small"
              icon="add"
              [text]="T.common.assign_me | translate"
              (clicked)="setAccountForCurrentOwner()">
            </app-button-transparent>
          </div>
        </div>
        <div class="col-12">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [useRadioButtons]="true"
            [displayError]="triggerErrors"
            [required]="true"
            [currentlySelectedSettingValue]="riskPrivacyStatuses.Public"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Privacy_Status"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="(T.common.privacy.one | translate) + '*'"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Impact_Type"
            [disableMargin]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.common.impact_type.many | translate: {impact: localisedImpact}"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="selection col-12 mb-2">
          <app-filter-dropdown-new
            [showOutlined]="true"
            [removeBorders]="true"
            [useSearch]="false"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Risk_Strategy"
            [singleSelect]="true"
            [disableMargin]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.common.strategy.one | translate"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="container-with-bottom-element d-flex flex-column col-12 mb-2">
          <div class="selection col-12 mb-2">
            <app-filter-dropdown-new
              [useSearch]="false"
              [showOutlined]="true"
              [removeBorders]="true"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Department"
              [disableMargin]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [removeIcon]="true"
              [label]="localisedDepartment"
              (onFilterUpdate)="handleFilterChange($event)">
            </app-filter-dropdown-new>
            <div class="bottom-element d-flex mt-1" *ngIf="employee?.departmentId > 0">
              <app-button-transparent
                size="small"
                icon="add"
                [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
                (clicked)="setMyDepartment()"
              ></app-button-transparent>
            </div>
          </div>
        </div>
        <div class="col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Project"
            [disableMargin]="true"
            [removeIcon]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="col-12 mb-2">
          <app-filter-dropdown-new
            [useSearch]="false"
            [showOutlined]="true"
            [removeBorders]="true"
            [disableMargin]="true"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Identified_By"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="T.defaultLocalizations.identified_by.one | translate"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
        <div class="description col-12 mb-2">
          <app-details-editable-field
            [useOutlinedInput]="true"
            [input]="form.controls.riskDescription.value ? form.controls.riskDescription.value : ''"
            [type]="editableFieldTypes.RichText"
            [canEdit]="true"
            (onUpdate)="updateRiskDescription($event)"
            (onInputChange)="updateRiskDescription($event)"
            (isInvalid)="isDescriptionInvalid($event)"
            [placeholder]="T.common.add_description | translate"
            ></app-details-editable-field>
        </div>

        <div class="d-flex align-items-center col-12 mt-3 mb-0">
          <span class="risk-index me-3">
            {{ T.defaultLocalizations.tag.many | translate }}
          </span>
        </div>
        <app-add-modal-tag-groups
          class="col-12 mt-0"
          [showTitle]="false"
          [showOutlined]="true"
          [removeBorders]="true"
          [useSearch]="false"
          [removeIcon]="true"
          [disableMargin]="true"
          [layoutClasses]="'col-12 col-lg-6 mb-2'"
          [filters]="filters"
          [tagGroupObjectType]="objectTypes.Risk"
          (onFiltersUpdated)="handleFilterChange($event)">
        </app-add-modal-tag-groups>
      </section>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        class="button d-none d-md-block"
        [fitToContainer]="true"
        [size]="ButtonSizes.Large"
        [text]="T.common.cancel | translate"
        buttonTheme="white"
        (clicked)="confirmClose()">
      </app-button-rectangle>
      <app-button-rectangle
        [size]="ButtonSizes.Large"
        class="modal-confirm"
        [buttonTheme]="ButtonThemes.Primary"
        [text]="T.common.save | translate"
        [disabled]="!validateState()"
        [loading]="isLoading"
        (clicked)="onSave($event)">
      </app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>

<ng-template #riskRAGTemplate>
    <div class="risk-rag d-flex" [style.border-color]="ragColour" [style.background-color]="ragBackgroundColour">
      <div class="details-icon">
        <app-details-icon [size]="24" [type]="riskTypes[selectedRiskType]" [backgroundFill]="ragColour"></app-details-icon>
      </div>
      <div>
        <span class="ms-2">{{ ragDescription }}</span>
      </div>
    </div>
  </ng-template>
